var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCarTypeDu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Location on",
    clipPath: "url(#clip0_12147_10323)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M26.88 5.515C26.58 4.63 25.74 4 24.75 4H8.25C7.26 4 6.435 4.63 6.12 5.515L3 14.5V26.5C3 27.325 3.675 28 4.5 28H6C6.825 28 7.5 27.325 7.5 26.5V25H25.5V26.5C25.5 27.325 26.175 28 27 28H28.5C29.325 28 30 27.325 30 26.5V14.5L26.88 5.515ZM8.25 20.5C7.005 20.5 6 19.495 6 18.25C6 17.005 7.005 16 8.25 16C9.495 16 10.5 17.005 10.5 18.25C10.5 19.495 9.495 20.5 8.25 20.5ZM24.75 20.5C23.505 20.5 22.5 19.495 22.5 18.25C22.5 17.005 23.505 16 24.75 16C25.995 16 27 17.005 27 18.25C27 19.495 25.995 20.5 24.75 20.5ZM6 13L8.25 6.25H24.75L27 13H6Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12147_10323"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarTypeDu);
export default __webpack_public_path__ + "static/media/CarTypeDU.3f6a7e1b.svg";
export { ForwardRef as ReactComponent };